import { useNavigate } from "react-router-dom";
import { ArrowsLeftRightIcon as ArrowsLeftRight, ChatCircleIcon as ChatCircle, XIcon as X } from "@phosphor-icons/react";

// Iter 63 — compare selection mode: toggle, the chosen pair, clear, and the chat hand-off (never auto-sends).
function Slot({ label, obj, testid }) {
  return (
    <span className="ml-mono text-[11px] min-w-0 break-words" data-testid={testid}>
      <span className="text-[var(--ml-text-secondary)] uppercase tracking-widest text-[10px]">{label}: </span>
      {obj ? (
        <span className="font-semibold text-[var(--ml-text-primary)]">{obj.label}</span>
      ) : (
        <span className="text-[var(--ml-text-secondary)]">— select a row —</span>
      )}
    </span>
  );
}

export function CompareSelectionBar({ selection, className = "" }) {
  const navigate = useNavigate();
  const { active, toggleActive, first, second, clear, question, path, notice } = selection;
  const status = !active ? "" : !first ? "Pick the first object." : !second ? `First object ${first.label}. Pick the second object.`
    : `Pair ready: ${first.label} and ${second.label}.`;
  return (
    <div
      className={`ml-card p-3 flex flex-wrap items-center gap-x-4 gap-y-2 min-w-0 ${className}`}
      role="region"
      aria-label="Compare objects"
      data-testid="compare-bar"
    >
      <button
        type="button"
        onClick={toggleActive}
        aria-pressed={active}
        className={`${active ? "ml-btn-primary" : "ml-btn-secondary"} flex items-center gap-1.5`}
        data-testid="compare-mode-toggle"
      >
        <ArrowsLeftRight size={14} weight="bold" />
        {active ? "Comparing…" : "Compare objects"}
      </button>
      {active && (
        <>
          <Slot label="First object" obj={first} testid="compare-first" />
          <Slot label="Second object" obj={second} testid="compare-second" />
          <button
            type="button"
            onClick={clear}
            disabled={!first && !second}
            className="ml-btn-ghost flex items-center gap-1 disabled:opacity-40"
            data-testid="compare-clear"
          >
            <X size={12} weight="bold" /> Clear selection
          </button>
          <button
            type="button"
            onClick={() => path && navigate(path)}
            disabled={!path}
            className="ml-btn-primary flex items-center gap-1.5 disabled:opacity-50"
            data-testid="compare-open"
            title={path ? "Opens the Code Analyst chat with the question prepared — you review and press Send" : "Select two objects first"}
          >
            <ChatCircle size={14} weight="bold" /> Open comparison in chat
          </button>
          {question && (
            <div className="w-full ml-mono text-[11px] text-[var(--ml-text-secondary)] break-words" data-testid="compare-question">
              Prepared question: <span className="text-[var(--ml-text-primary)]">{question}</span> (not sent until you press Send in chat)
            </div>
          )}
          {notice && (
            <div className="w-full text-xs text-[#a2191f] break-words" role="alert" data-testid="compare-notice">
              {notice}
            </div>
          )}
          <span className="sr-only" aria-live="polite" data-testid="compare-status">{status}</span>
        </>
      )}
    </div>
  );
}

export default CompareSelectionBar;
